import React, { useRef } from 'react'
import style from './hero-video.mod.scss'
import { motion } from 'framer-motion'
import { useAttachDatocmsFileVideo } from '../lib/datocms-video-playback'

const HeroVideo = ({ video, text, thumbnail }) => {
  const videoRef = useRef(null)
  useAttachDatocmsFileVideo(videoRef, video)

  return (
    <div className={style.hero}>
      <div className={style.hero__video}>
        <motion.div
          className={style.hero__videoMotion}
          initial={{ opacity: 0.4 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 7, duration: 3 }}
        >
          <video ref={videoRef} poster={thumbnail} muted autoPlay playsInline />
        </motion.div>
      </div>
      <div className={style.hero__wrapper}>
        <motion.div
          className={style.hero__text}
          dangerouslySetInnerHTML={{ __html: text }}
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ delay: 7, duration: 1.5 }}
        />
      </div>
    </div>
  )
}

export default HeroVideo
